const Utils = {
  getType: function(name) {
    const city = localStorage.getItem('city');
    if (city) return city;
    const url = name ?? window.location.hostname;
    const [ , , subdomain]  = url.split('.').reverse();
    if (subdomain && subdomain !== 'www' && subdomain !== 'staging') return subdomain;
    name = url.includes('hipster') && url !== 'www.hipster.io' && url !== 'hipster.io' && url !== 'staging.hipster.io' ? url.replace('hipster').replace('.io').replace('www.') : 'dc';
    return name;
  },
  getMobileOperatingSystem: function() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return false;
  }
};

export default Utils;
